var _ssoCache_get, _ssoCache_get1, _ssoCache_get2, _ssoCache_get_signUpSuggestions, _ssoCache_get3;
import { createContextStore } from "@faire/web--source/ui/hooks/ContextStore";
import { ISignUpSuggestions } from "@faire/web-api--source/indigofair/data/ISignUpSuggestions";
import { SocialSignOnProvider } from "@faire/web-api--source/indigofair/data/SocialSignOnProvider";
import { ssoCache } from "@faire/retailer/features/SignUp/SSORequestData";
export var BLANK_SIGN_UP_SUGGESTIONS = ISignUpSuggestions.build({
    email_address: "",
    first_name: "",
    last_name: "",
    profile_image_url: "",
    provider: SocialSignOnProvider.SOCIAL_SIGN_ON_PROVIDER_UNKNOWN
});
var _ssoCache_get_signUpSuggestions1, _ssoCache_get_isActive, _ssoCache_get_id_token, _ssoCache_get_signUpSuggestions_provider;
var _createContextStore = createContextStore({
    signUpSuggestions: (_ssoCache_get_signUpSuggestions1 = (_ssoCache_get = ssoCache.get()) === null || _ssoCache_get === void 0 ? void 0 : _ssoCache_get.signUpSuggestions) !== null && _ssoCache_get_signUpSuggestions1 !== void 0 ? _ssoCache_get_signUpSuggestions1 : BLANK_SIGN_UP_SUGGESTIONS,
    isActive: (_ssoCache_get_isActive = (_ssoCache_get1 = ssoCache.get()) === null || _ssoCache_get1 === void 0 ? void 0 : _ssoCache_get1.isActive) !== null && _ssoCache_get_isActive !== void 0 ? _ssoCache_get_isActive : false,
    userClickedSSOButton: false,
    id_token: (_ssoCache_get_id_token = (_ssoCache_get2 = ssoCache.get()) === null || _ssoCache_get2 === void 0 ? void 0 : _ssoCache_get2.id_token) !== null && _ssoCache_get_id_token !== void 0 ? _ssoCache_get_id_token : "",
    // Provider chosen by the user
    provider: (_ssoCache_get_signUpSuggestions_provider = (_ssoCache_get3 = ssoCache.get()) === null || _ssoCache_get3 === void 0 ? void 0 : (_ssoCache_get_signUpSuggestions = _ssoCache_get3.signUpSuggestions) === null || _ssoCache_get_signUpSuggestions === void 0 ? void 0 : _ssoCache_get_signUpSuggestions.provider) !== null && _ssoCache_get_signUpSuggestions_provider !== void 0 ? _ssoCache_get_signUpSuggestions_provider : SocialSignOnProvider.SOCIAL_SIGN_ON_PROVIDER_UNKNOWN,
    // All possible providers
    providers: [],
    errorMessage: "",
    mfaDescription: "",
    mfaTitle: "",
    mfaOptions: [],
    promptSSO: false,
    userHasPassword: false,
    showConfirmPasswordView: false,
    strictLocalize: undefined
}), useSSOContextStore = _createContextStore.useStore, SSOContextStoreProvider = _createContextStore.Provider;
export { useSSOContextStore, SSOContextStoreProvider };
